import { render } from "./Sidbar.vue?vue&type=template&id=30be0f6c&scoped=true"
import script from "./Sidbar.vue?vue&type=script&lang=js"
export * from "./Sidbar.vue?vue&type=script&lang=js"

import "./Sidbar.vue?vue&type=style&index=0&id=30be0f6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30be0f6c"]])

export default __exports__